import Axios from '.';

const axiosBaseQuery =
  () =>
  async ({ url, method, data, params, baseURL, headers, responseType }) => {
    try {
      const result = await Axios({ baseURL, url, method, data, params, headers, responseType });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export default axiosBaseQuery;
